import { ApiResponseObject } from "../../../types";
import { axios } from "../../../utils/axios";
import {
  GetListaIskoriscenihAMPayload,
  IEvidentiranjeMarkicaPayload,
  IPonistiEvidentiraniOpsegPayload,
  ListaIskoriscenihAM,
  StavljanjeMarkicaUPrometPayload,
} from "./usedStamps.types";

const createEvidentiranjeMarkica = (
  payload: IEvidentiranjeMarkicaPayload
): Promise<ApiResponseObject<boolean>> => {
  return axios.post("/evidentiranjeMarkica", payload);
};

const getListaIskoriscenihAkciznihMarkica = (
  payload: GetListaIskoriscenihAMPayload
): Promise<ApiResponseObject<ListaIskoriscenihAM>> => {
  return axios.post("/listaEvidentiranihAkciznihMarkica", payload);
};

const postStavljanjeMarkicaUPromet = (
  payload: StavljanjeMarkicaUPrometPayload
): Promise<ApiResponseObject<boolean>> => {
  return axios.post("/stavljanjeMarkicaUPromet", payload);
};

const postPonistiEvidentiraniOpseg = (
  payload: IPonistiEvidentiraniOpsegPayload
): Promise<ApiResponseObject<boolean>> => {
  return axios.post("/ponistiEvidentiraniOpseg", payload);
};

export const usedStampsRepo = {
  postStavljanjeMarkicaUPromet,
  getListaIskoriscenihAkciznihMarkica,
  createEvidentiranjeMarkica,
  postPonistiEvidentiraniOpseg,
};
